<template>
  <div class="breadcrumb flex flex-between">
    <div style="margin-top: 5px;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="crumb in crumbs" :key="crumb" class="breadcrumb-item">{{ crumb }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right mgt10">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ["crumbs"],
};
</script>
<style scoped>
.breadcrumb {
  margin-bottom: 5px;
  height: 40px;
}
.breadcrumb-item {
  font-size: 15px;
  line-height: 28px;
}
.right {
  text-emphasis: right;
}
</style>
